enum IsinStatus {
    N = "New",
    U = "Updated",
    D = "Deleted",
    I = "In Default",
}

export default IsinStatus;